// extracted by mini-css-extract-plugin
export default {"review-prompt-box":"review-prompt-box--mp-XnSZd","reviewPromptBox":"review-prompt-box--mp-XnSZd"};